import React from "react";
import { useNavigate } from "react-router-dom";
import "../assests/CSS/FeaturesComponentFive.css";
import { featuresFive } from "./data";

export default function FeaturesComponentFive() {
  const navigate = useNavigate();

  const handleContactClick = (index) => {
    if (index === 2) { 
      navigate("/#inquiry-form"); 
    }
  };

  return (
    <section className="fc5">
      <div className="fc5-header">
        <h2>{featuresFive.title}</h2>
        <p>{featuresFive.subtitle}</p>
      </div>

      <div className="fc5-cards">
        {featuresFive.cards.map((card) => (
          <div key={card.id} className="fc5-card">
            <span className={`fc5-icon fc5-icon-${card.id}`}>
              <h3>{card.title}</h3>
              <img src={card.icon} alt={card.title} />
            </span>
            
            <p>{card.desc}</p>
          </div>
        ))}
      </div>

      <div className="fc5-cta">
        <h3>{featuresFive.ctaTitle}</h3>
        <p>{featuresFive.ctaDesc} <span style={{ color: "#113157", fontWeight: "bold" }}>Thhiya</span><span style={{ color: "red", fontSize: "2.5rem", lineHeight: "1" }}>.</span> </p>
        <div className="fc5-buttons">
          {featuresFive.buttons.map((btn, index) => (
            <button
              key={btn.id}
              className={`fc5-btn ${btn.type === "primary" ? "primary" : "secondary"}`}
              onClick={() => handleContactClick(index)}
            >
              {btn.label}
            </button>
          ))}
        </div>
      </div>

      <p className="fc5-disclaimer">{featuresFive.disclaimer}</p>
    </section>
  );
}
